<template>
    <splashscreen>
        <p class="text-lg mt-0 mb-6">
            <i18n-t keypath="accessSuspend.subtitle1" tag="span"> {{ accountName }} </i18n-t><br />
            {{ $t('accessSuspend.subtitle2') }}
        </p>
        <template v-if="onChildAccount">
            <activix-button type="primary" :loading="loading" @click="goBack">
                {{ $t('accessSuspend.goBack') }}
            </activix-button>
            <activix-button class="ml-4" :loading="loading" @click="goHome">
                {{ $t('accessSuspend.goHome') }}
            </activix-button>
        </template>
        <template v-else>
            <activix-button type="primary" :loading="loading" @click="reload">
                {{ $t('accessSuspend.reload') }}
            </activix-button>
            <activix-button class="ml-4" @click="logout">
                {{ $t('accessSuspend.logout') }}
            </activix-button>
        </template>
    </splashscreen>
</template>

<script>
    import { mapActions } from 'pinia';
    import { useUserStore } from '@/store/modules/user/store.js';
    import { useAccountStore } from '@/store/modules/account/store.js';
    import Splashscreen from '../layouts/Splashscreen.vue';

    // Pinia
    import { useContextStore } from '../store/modules/context/store.ts';

    export default {
        components: {
            Splashscreen,
        },

        data() {
            return {
                loading: false,
            };
        },

        computed: {
            contextAccount() {
                return useAccountStore().contextAccount;
            },

            parentUser() {
                return useUserStore().parentAuthUser;
            },

            accountName() {
                return this.contextAccount.name
                    ? this.contextAccount.name
                    : this.parentUser.account.name;
            },

            onChildAccount() {
                return (
                    this.contextAccount.id && this.parentUser.account.id != this.contextAccount.id
                );
            },
        },

        methods: {
            ...mapActions(useContextStore, ['setContextAccountAction']),

            reload() {
                this.loading = true;
                window.location.reload();
            },

            logout() {
                this.$auth.logout();
            },

            goBack() {
                this.loading = true;
                this.setContextAccountAction(this.parentUser.account.id);
                this.$router.back();
            },

            goHome() {
                this.loading = true;
                this.setContextAccountAction(this.parentUser.account.id);
                this.$router.push('/');
            },
        },
    };
</script>
